import React, { createContext, useContext, useEffect, useState } from "react";
import api from "../api";

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const stored = localStorage.getItem("user");
    const token = localStorage.getItem("token");
    if (stored && token) {
      try { setUser(JSON.parse(stored)); } catch { localStorage.removeItem("user"); localStorage.removeItem("token"); }
    }
    const expired = () => { localStorage.removeItem("user"); localStorage.removeItem("token"); setUser(null); };
    window.addEventListener("karmex:session-expired", expired);
    setLoading(false);
    return () => window.removeEventListener("karmex:session-expired", expired);
  }, []);

  async function login(username, password) {
    const { data } = await api.post("/auth/login", { username, password });
    localStorage.setItem("token", data.token);
    localStorage.setItem("user", JSON.stringify(data.user));
    setUser(data.user);
  }

  async function register(name, username, email, password, acceptLegal) {
    const { data } = await api.post("/auth/register", {
      name,
      username,
      email,
      password,
      acceptLegal,
    });
    if (data.token) {
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.user));
      setUser(data.user);
    }
    return data;
  }

  async function confirmRegistration(username, code) {
    const { data } = await api.post("/auth/confirm", { username, code });
    return data;
  }

  function logout() {
    localStorage.removeItem("token");
    localStorage.removeItem("user");
    setUser(null);
  }

  async function updateProfile(profile) {
    const { data } = await api.patch("/auth/profile", profile);
    localStorage.setItem("user", JSON.stringify(data));
    setUser(data);
    return data;
  }

  async function updatePreferences(preferences) {
    const { data } = await api.patch("/auth/preferences", preferences);
    localStorage.setItem("user", JSON.stringify(data));
    setUser(data);
    return data;
  }

  return (
    <AuthContext.Provider value={{ user, loading, login, register, confirmRegistration, logout, updateProfile, updatePreferences }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
